<script>
import { mergeData } from 'vue-functional-data-merge';

export default {
  functional: true,
  inject: ['cssClasses'],
  props: {
    row: { type: Object, required: true },
    column: { type: Object, required: true },
  },
  render(createElement, {
    props, injections, data, children,
  }) {
    // console.log('createTableTd');
    const { cssClasses } = injections;
    const { row, column } = props;

    const classes = {};
    if (column.className) classes[column.className] = true;
    if (column.align) classes[`${cssClasses.column}-${column.align}`] = true;
    if (row.cellClassName && row.cellClassName[column.key]) {
      classes[row.cellClassName[column.key]] = true;
    }

    const localData = {
      class: classes,
    };

    return createElement('td', mergeData(data, localData), children);
  },
};
</script>
